var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNbb(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 22,
    viewBox: "0 0 20 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 15.6H15.2V15.4V8.8C15.2 7.26985 14.5448 6.11263 13.5609 5.34276C12.5823 4.57705 11.2869 4.2 10.0013 4.2H9.99874C8.71308 4.2 7.4177 4.57705 6.43909 5.34276C5.45518 6.11263 4.8 7.26985 4.8 8.8V15.4V15.6H5H15ZM8.75 17.4H8.55V17.6V18.7C8.55 19.4409 9.22433 20 10 20C10.7757 20 11.45 19.4409 11.45 18.7V17.6V17.4H11.25H8.75ZM17.3 15.4V15.6H17.5H19.8V17.4H13.75H13.55V17.6V18.7C13.55 20.389 11.9856 21.8 10 21.8C8.01442 21.8 6.45 20.389 6.45 18.7V17.6V17.4H6.25H0.2V15.6H2.5H2.7V15.4V8.8C2.7 6.90126 3.41704 5.43443 4.52844 4.3867C5.64347 3.33556 7.16436 2.69856 8.77625 2.48515L8.95 2.46214V2.28688V0.2H11.05V2.28688V2.46214L11.2237 2.48515C12.8356 2.69856 14.3565 3.33556 15.4716 4.3867C16.583 5.43443 17.3 6.90126 17.3 8.8V15.4Z",
    fill: "#171719",
    stroke: "white",
    strokeWidth: 0.4
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNbb);
export default __webpack_public_path__ + "static/media/NBB.5c325a778dac8f8dc323cf534ee037e4.svg";
export { ForwardRef as ReactComponent };